import { render } from "./pie_chart.svg?vue&type=template&id=1655fecd"
const script = {}
script.render = render

export default script